import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AnchorContentModel } from '@libs/cms/models';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-anchor',
  template: '',
  styleUrls: ['./anchor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  host: {
    '[id]': 'data().anchor',
  },
})
export class AnchorComponent extends ContentBaseComponent<AnchorContentModel> {
}
